import React, { useState } from "react";
import { Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import "../styles/global-background.css";
import "../styles/ProductsPage.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAccount } from "wagmi";
const ProductsPage: React.FC = () => {
  const { address } = useAccount();
  const navigate = useNavigate();
  const [language, setLanguage] = useState<'en' | 'zh'>('zh');
  
  // Project cards data
  const projectCards = [
    {
      icon: "🌙",
      title: "币圈重生之归零边缘",
      description: language === 'en'
        ? "A cryptocurrency rebirth simulator where you navigate the volatile crypto market, make strategic investments, and experience the highs and lows of digital asset trading."
        : "你陷入了亏完再重生的循环，企图找到突破循环的方式。运气，知识，人脉，究竟什么能将你带到彼岸。",
      buttonText: language === 'en' ? "Play Now" : "立即游玩",
      onClick: () => {
        if (!address) {
          message.info(language === 'en' ? "Please connect your wallet first" : "将以游客身份登录");
          setTimeout(() => {
            window.open("https://novacrafterlab.xyz/reloader/", "_blank");
          }, 1000);
          return;
        }
        window.open("https://novacrafterlab.xyz/reloader/", "_blank");
      },
      comingSoon: false
    },
    {
      icon: "🎮",
      title: language === 'en' ? "币圈大乱斗" : "币圈大乱斗",
      description: language === 'en'
        ? "Experience authentic cryptocurrency culture in this Three Kingdoms Kill-style card game. Take on the roles of famous crypto personalities, deploy market strategies, and outmaneuver your opponents in this strategic battle of wits and fortune."
        : "韭菜想打破宿命的循环是与天斗。而这次则是与人斗，选择你喜欢的币圈人物，来到这场镰刀互割的游戏中！",
      buttonText: language === 'en' ? "Coming Soon" : "立即游玩",
      onClick: () => {
        if (!address) {
          message.info(language === 'en' ? "Please connect your wallet first" : "将以游客身份登录");
          setTimeout(() => {
            window.open(`https://novacrafterlab.xyz/cryptokill`, "_blank");
          }, 1000);
          return;
        }
        window.open(`https://novacrafterlab.xyz/cryptokill/?address=${address}`, "_blank");
      },
      comingSoon: false
    },
    {
      icon: "🚀",
      title: "",
      description: language === 'en'
        ? "More games coming soon..."
        : "更多游戏即将推出...",
      buttonText: language === 'en' ? "Coming Soon" : "即将推出",
      onClick: () => message.info(language === 'en' ? "In development. Please stay tuned!" : "正在开发中，敬请期待！"),
      comingSoon: true
    },
    {
      icon: "🧠",
      title: "",
      description: language === 'en'
        ? "More games coming soon..."
        : "更多游戏即将推出...",
      buttonText: language === 'en' ? "Coming Soon" : "即将推出",
      onClick: () => message.info(language === 'en' ? "In development. Please stay tuned!" : "正在开发中，敬请期待！"),
      comingSoon: true
    },
    {
      icon: "🏰",
      title: "",
      description: language === 'en'
        ? "More games coming soon..."
        : "更多游戏即将推出...",
      buttonText: language === 'en' ? "Coming Soon" : "即将推出",
      onClick: () => message.info(language === 'en' ? "In development. Please stay tuned!" : "正在开发中，敬请期待！"),
      comingSoon: true
    },
    {
      icon: "🌊",
      title: "",
      description: language === 'en'
        ? "More games coming soon..."
        : "更多游戏即将推出...",
      buttonText: language === 'en' ? "Coming Soon" : "即将推出",
      onClick: () => message.info(language === 'en' ? "In development. Please stay tuned!" : "正在开发中，敬请期待！"),
      comingSoon: true
    }
  ];

  return (
    <div className="nova-container">
      <div className="nova-grid" />
      
      <Navbar language={language} />
      
      <div className="content">
        <div className="title-section">
          <h1 className="nova-title">{language === 'en' ? "Our Products" : "游戏产品"}</h1>
          <p className="nova-subtitle">
            {language === 'en'
              ? "Explore our blockchain-powered games and experiences"
              : "探索我们基于区块链的游戏和体验"}
          </p>
        </div>
        
        <div className="projects-grid">
          {projectCards.map((card, index) => (
            <div className={`project-card ${card.comingSoon ? 'coming-soon-card' : ''}`} key={index}>
              <div className="card-icon">{card.icon}</div>
              <h2 className="card-title">{card.title}</h2>
              <p className="card-description">{card.description}</p>
              <Button
                className="card-button"
                onClick={card.onClick}
              >
                {card.buttonText}
              </Button>
            </div>
          ))}
        </div>

        <Footer language={language} setLanguage={setLanguage} />
      </div>
    </div>
  );
};

export default ProductsPage; 